export const userAccountStatus = {
  DELETED: 'deleted',
};
